// extracted by mini-css-extract-plugin
export default {"accordions":"YbH2eaI+3inzRB+Ly83oou8fUBdPNhCAS9XIBjKjbug="};